module.exports = __webpack_public_path__ + "img/allianz-turkish-movie-04.65f5a49c.jpg";